import React, { useContext } from "react"
import { FishRoomPage as SharedFishRoomPage } from "@stjeans/shared-frontend/fish-room"
import AppContext from "../../AppContext.jsx"
import api from "../../api.js"
import * as helpers from "../../helpers.js"

export default function FishRoomPage() {
    const { app } = useContext(AppContext)

    return (
        <SharedFishRoomPage
            api={api}
            app={app}
            helpers={helpers}
            onEditOrder={(order) => {
                if (order?.id) {
                    window.open(`/v2/orders/${order.id}/edit`, "_blank", "noopener,noreferrer")
                }
            }}
        />
    )
}
